import { TrendingUp, GraduationCap, Users, Trophy, Award } from "lucide-react";

const items = [
  {
    icon: TrendingUp,
    headline: "+6 MPH / +13 LBS",
    title: "2025 Athletes On My Program",
    body: "Average velocity and strength gains posted by the pitchers I trained in 2025 — measured, not estimated.",
    big: true,
  },
  {
    icon: Award,
    headline: "2026 DRAFT",
    title: "Drafted By The Atlanta Braves",
    body: "Selected in the 2026 MLB Draft by the Atlanta Braves organization — the ultimate proof this training path works.",
  },
  {
    icon: Users,
    headline: "4+ YEARS",
    title: "Coaching Athletes",
    body: "Helping high school and college pitchers unlock their next gear, in person and remotely.",
  },
  {
    icon: Trophy,
    headline: "MLB-TRAINED",
    title: "Coached By The Best",
    body: "Mentored by 10+ MLB coaches and pro pitching minds across my career.",
  },
  {
    icon: GraduationCap,
    headline: "90 → 95+",
    title: "It Works — I Lived It",
    body: "Hit 95+ mph and added 25+ lbs of strength during my D1 career at Wichita State. Same path I coach you through.",
  },
];

export default function StatsBento() {
  return (
    <section
      id="results"
      data-testid="stats-section"
      className="relative bg-[#0a0a0a] py-24 md:py-32 px-6 md:px-10"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-px bg-[#eab308]" />
              <span className="font-condensed uppercase tracking-[0.25em] text-xs text-[#eab308]">
                The Track Record
              </span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
              Built On Real
              <br />
              Reps. Not Theory.
            </h2>
          </div>
          <p className="max-w-md text-neutral-400 text-base md:text-lg">
            Every drill, every cue, every program is forged from the exact path
            that took me from undersized arm to professional-level velocity.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {items.map((it, i) => {
            const Icon = it.icon;
            const span = it.big ? "md:col-span-2 md:row-span-2" : "";
            return (
              <div
                key={i}
                data-testid={`stat-card-${i}`}
                className={`group relative bg-[#141414] border border-[#2a2a2a] hover:border-[#eab308] transition-all p-7 md:p-8 ${span} overflow-hidden`}
              >
                <div className="absolute -top-12 -right-12 w-40 h-40 rounded-full bg-[#eab308] opacity-0 group-hover:opacity-10 transition-opacity blur-2xl" />
                <div className="flex items-start justify-between mb-8 relative">
                  <Icon className="text-[#eab308]" size={28} strokeWidth={2} />
                  <span className="font-condensed uppercase text-[10px] tracking-[0.2em] text-neutral-500">
                    0{i + 1}
                  </span>
                </div>
                <div
                  className={`font-display ${
                    it.big ? "text-6xl md:text-8xl" : "text-4xl md:text-5xl"
                  } text-[#eab308] mb-3 leading-none`}
                >
                  {it.headline}
                </div>
                <h3 className="font-condensed uppercase tracking-wider text-lg md:text-xl mb-3">
                  {it.title}
                </h3>
                <p className="text-neutral-400 text-sm md:text-base max-w-md">
                  {it.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
